module.exports = __webpack_public_path__ + "img/publishing_schedule_icon.efc9d537.svg";